'use client';

import { UseCaseForm } from '@prismo-io/feature-organization/forms/use-case';
import { type ComponentProps, type FC, useCallback } from 'react';
import { useSetOrganizationMetadata } from './use-set-organization-metadata';
type FormProps = ComponentProps<typeof UseCaseForm>;
type Props = Omit<FormProps, 'onSubmit'>;
export const UseCasesFormWrapper: FC<Props> = props => {
  const {
    trigger: setMetadata
  } = useSetOrganizationMetadata();
  const onSubmit: FormProps['onSubmit'] = useCallback(data => {
    setMetadata({
      ...data
    });
  }, [setMetadata]);
  return <UseCaseForm {...props} withFreeOption onSubmit={onSubmit} data-sentry-element="UseCaseForm" data-sentry-component="UseCasesFormWrapper" data-sentry-source-file="use-cases.wrapper.tsx" />;
};